import { Component, OnInit, Injector, Input } from '@angular/core';
import { BaseDialog } from '../../Dialog-types/base-dialog';
import { ButtonInfo } from 'src/app/common/UI-Components/helperClasses/value-and-display.class';
import { Validators } from '../../../Validators/validators';
import { IProject, IScan } from './import-scans-util';
import { Subject, Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { LayersState } from 'src/app/Store/layers.state/layers.state';
import { LayerTreeNode } from 'src/app/common/Models/UI/ui-tree-node.model';
import { takeUntil } from 'rxjs/operators';
import { ServerApi } from 'src/app/services/api.services/server.api';
import { PointCloudSvc } from 'src/app/services/api.services/point-cloud.service';
import { MatIcon } from '@angular/material/icon';
import { SelectionBoxLayersComponent } from '../../../UI-Components/selection-box-layers/selection-box-layers.component';
import { InputBoxComponent } from '../../../UI-Components/input-box/input-box.component';
import { ZoneSelectionBoxComponent } from '../../../UI-Components/zone-selection-box/zone-selection-box.component';
import { ExpansionBoxComponent } from '../../../UI-Components/expansion-box/expansion-box.component';
import { ImportScansProjectGridComponent } from './import-scans-project-grid/import-scans-project-grid.component';
import { ImportScansScanGridComponent } from './import-scans-scan-grid/import-scans-scan-grid.component';
import { LAYER_TYPES } from 'src/app/Store/layers.state/layers.model';

@Component({
    selector: 'ins-import-scans-dialog',
    templateUrl: './import-scans-dialog.component.html',
    styleUrls: ['./import-scans-dialog.component.scss', './../shared-dialogs-ui.scss', './../../../UI-Components/shared-UI-components.scss'],
    imports: [MatIcon, SelectionBoxLayersComponent, InputBoxComponent, ZoneSelectionBoxComponent, ExpansionBoxComponent, ImportScansProjectGridComponent, ImportScansScanGridComponent]
})
export class ImportScansDialogComponent extends BaseDialog implements OnInit {
  public buttonsInfo: ButtonInfo[] = [];
  public projectsToShow: IProject[] = [];
  public scansToShow: IScan[] = [];
  layersTree$: Observable<LayerTreeNode[]>;

  public expandScansList: Subject<boolean> = new Subject();

  @Input() selectedParentLayer: string = "";
  @Input() layerName: string = "";
  @Input() selectedZone: string = "";
  @Input() selectedProject: IProject;
  @Input() selectedScans: IScan[] = [];
  @Input() defaultResolution: string = "4096";

  showProjectLoading: boolean = false;
  showScansLoading: boolean = false;

  ignoredLayersTypes = [LAYER_TYPES.General];
  
  constructor(public injector: Injector,
    public validators: Validators,
    private readonly pointCloudSvc: PointCloudSvc,
    private readonly serverApi: ServerApi, private store: Store) {
    super(injector);
    this.layersTree$ = this.store.select(LayersState.getLayersTree);
  }

  ngOnInit() {
    this.showProjectLoading = true;
    this.pointCloudSvc.getProjects()
      .subscribe({
        next: (res: any) => {
          this.projectsToShow = res;
          this.showProjectLoading = false;
        },
        error: (err) => {
          this.serverApi.createNotifiactionDialogForHttpCrisis(err, 'Error in loading projects. Please try later');
        }
      });

    this.buttonsInfo.push(
      new ButtonInfo('cancel', 'Cancel'),
      new ButtonInfo('import', 'Import')
    );

    if (this.selectedParentLayer === "") {
      this.layersTree$.pipe(takeUntil(this.unsubscribe)).subscribe((layers) => {
        this.selectedParentLayer = new LayerTreeNode('0', 'Root', undefined, layers).id;
      });
    }
  }

  resolutionChanged(resolution): void {
    this.defaultResolution = resolution;
  }

  loadScansForProject(project: IProject): void {
    this.layerName = project.displayName;
    this.selectedProject = project;
    this.scansToShow = [];
    this.selectedScans = [];
    this.showScansLoading = true;
    this.updateDialogValidity(true);

    this.pointCloudSvc.getScans(project)
      .subscribe({
        next: (res: any) => {
          this.scansToShow = res;
          this.showScansLoading = false;
          this.expandScansList.next(true);
        },
        error: (err) => {
          this.serverApi.createNotifiactionDialogForHttpCrisis(err, 'Error in loading scans. Please try later');
        }
      });
  } 

  scanSelectionChanged(scan: IScan[]): void {
    this.selectedScans = scan;
    this.updateDialogValidity(true);
  }  

  onLayerValueChanged(selectedParentLayer: string) {
    this.updateDialogValidity(true);
  }

  onZoneValueChanged(selectedZone: string) {
    this.updateDialogValidity(true);
  }

  public defineDialogModel(): void {
    this.dialogModel.initModel(
      ['selectedParentLayer', this.selectedParentLayer],
      ['layerName', this.layerName],
      ['selectedZone', this.selectedZone],
      ['selectedProject', this.selectedProject],
      ['selectedScans', this.selectedScans],
      ['defaultResolution', this.defaultResolution]);
  }

  public updateDialogValidity(event: any): void {
    this.isDialogValid = (this.selectedParentLayer != "-1" && this.layerName && this.selectedZone && this.selectedProject?.name && this.selectedScans.length > 0 );
  }

  onChanges(): void {}
}
